import * as React from 'react';
import HeaderNavigation from '../../headers/HeaderNavigation/HeaderNavigation';
import UserInfo from '../../headers/UserInfo/UserInfo';
import PageHeader from '../../headers/PageHeader/PageHeader';
import AlanyticsHeaderPart from './AlanyticsHeaderPart/AlanyticsHeaderPart';
import { connect } from 'react-redux';
import { IProject } from '../../../models/IProject';
import { IChangeEnvironmentParam } from '../../../redux/projects/saga.projects';
import { Environment } from '../../../const/environment';

type AnalyticsHeaderProps = {
    projectName: string
    project: IProject
    tier: string
    environment: Environment
    changeEnvironment: (param: IChangeEnvironmentParam) => void
    refreshAlanyticsData: () => void
}

function AnalyticsHeader({ projectName, project, tier, environment, changeEnvironment, refreshAlanyticsData }: AnalyticsHeaderProps) {
    return <PageHeader
        leftPart={
            <React.Fragment>
                <HeaderNavigation projectName={projectName} />
                <AlanyticsHeaderPart
                    project={project}
                    tier={tier}
                    environment={environment}
                    changeEnvironment={changeEnvironment}
                    refreshAlanyticsData={refreshAlanyticsData} />
            </React.Fragment>
        }
        rightPart={
            <React.Fragment>
                <UserInfo hideBalanceBlock={true} />
            </React.Fragment>
        }
    />;
}


function mapStateToProps({ projectsInfo, user }, ownProps) {
    return {
        project: projectsInfo.currentProject,
        tier: user.tier
    };
}

function mapDispatchToProps(dispatch) {
    return {
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(AnalyticsHeader);